<template>
  <div class="user">
    <div>
      <nav-bar
        fixed
        z-index="99"
        title="个人中心"
        left-text="首页"
        @click-left="$router.push('/')"
        right-text="退出"
        @click-right="outLogin"
      />
      <div style="height: 46px"></div>
    </div>
    <div class="header">
      <img class="bg" src="@assets/img/bg.jpg" />
      <div class="header-img">
        <img :src="userInfo.avatar" />
        <div
          class="coach-status"
          v-if="this.$store.state.app.userCategory == 2"
        >
          <!-- <span v-if="isShow == 0">审核中</span>
          <span v-if="isShow == 1">已审核</span>
          <span v-if="isShow == 2">已拒绝</span> -->

          <!-- <span v-if="(userInfo.isShow === 0 && [0, 2].includes(userInfo.coachType)) ||
        (userInfo.welfareStatus === 0 && [1, 2].includes(userInfo.coachType)) ||
        (userInfo.cardStatus === 0 && userInfo.isCardCoach == 1)">
            审核中
            <span>({{ checkCoachStatus(userInfo, 0) }})</span>
          </span>

          <span v-else-if="(userInfo.isShow === 2 && [0, 2].includes(userInfo.coachType)) ||
        (userInfo.welfareStatus === 2 && [1, 2].includes(userInfo.coachType)) ||
        (userInfo.cardStatus === 2 && userInfo.isCardCoach == 1)">
            已拒绝
            <span>({{ checkCoachStatus(userInfo, 2) }})</span>
          </span>

          <span v-else-if="(userInfo.isShow === 1 && [0, 2].includes(userInfo.coachType)) ||
        (userInfo.welfareStatus === 1 && [1, 2].includes(userInfo.coachType)) ||
        (userInfo.cardStatus === 1 && userInfo.isCardCoach == 1)">
            已审核
            <span>({{ checkCoachStatus(userInfo, 1) }})</span>
          </span> -->
          <span
            v-if="checkCoachStatus(userInfo, 1) !== null"
            :style="{
              color: [0, 2].includes(checkCoachStatus(userInfo, 1))
                ? '#137871'
                : '',
            }"
          >
            <span>平台教练</span>
            <span v-if="checkCoachStatus(userInfo, 1) === 0">(审核中)</span>
            <span v-else-if="checkCoachStatus(userInfo, 1) === 2"
              >(已拒绝)</span
            >
            <!-- <span v-else-if="checkCoachStatus(userInfo, 1) === 1">已审核</span> -->
            <span>；</span>
          </span>

          <span
            v-if="checkCoachStatus(userInfo, 2) !== null"
            :style="{
              color: [0, 2].includes(checkCoachStatus(userInfo, 2))
                ? '#137871'
                : '',
            }"
          >
            <span>公益教练</span>
            <span v-if="checkCoachStatus(userInfo, 2) === 0">(审核中)</span>
            <span v-else-if="checkCoachStatus(userInfo, 2) === 2"
              >(已拒绝)</span
            >
            <!-- <span v-else-if="checkCoachStatus(userInfo, 2) === 1">已审核</span> -->
            <span>；</span>
          </span>

          <span
            v-if="checkCoachStatus(userInfo, 3) !== null"
            :style="{
              color: [0, 2].includes(checkCoachStatus(userInfo, 3))
                ? '#137871'
                : '',
            }"
          >
            <span>卡牌教练</span>
            <span v-if="checkCoachStatus(userInfo, 3) === 0">(审核中)</span>
            <span v-else-if="checkCoachStatus(userInfo, 3) === 2"
              >(已拒绝)</span
            >
          </span>
        </div>
      </div>
      <div
        class="header-flex acea-row row-center"
        v-if="$store.state.app.userCategory == 1"
      >
        <a href="/user/replay" class="header-num">
          <div class="name">我的评价</div>
          <div>{{ userInfo.commentNum }}</div>
        </a>
      </div>
      <div
        class="header-flex acea-row row-center"
        v-if="$store.state.app.userCategory == 2"
      >
        <div class="header-num">
          <div class="name">我的评价</div>
          <div>{{ userInfo.commentNum }}</div>
        </div>
        <div class="header-num">
          <div class="name">预约次数</div>
          <div>{{ userInfo.sales || 0 }}次</div>
        </div>
        <div class="header-num">
          <div class="name">成交金额</div>
          <div>￥ {{ userInfo.dealMoney }}</div>
        </div>
        <div class="header-num" @click="$router.push('/user/user_promotion')">
          <div class="name">可提余额</div>
          <div>￥{{ userInfo.brokeragePrice }}</div>
        </div>
      </div>
    </div>
    <div class="order-list" @click="$router.push('/order/list?userCategory=1')">
      <cell title="" value="全部订单" is-link>
        <template #title>
          <badge :dot="!!userInfo.newUserOrderNum">我的订单</badge>
          <span style="font-size: 0.22rem; color: #666"> 我预约教练的订单</span>
        </template>
      </cell>
    </div>
    <div
      class="order-list"
      @click="$router.push('/order/list?userCategory=2')"
      v-if="$store.state.app.userCategory == 2 && userInfo.coachType != 3"
    >
      <cell title="" value="全部订单" is-link>
        <template #title>
          <!-- <span>客户订单</span> -->
          <badge :dot="!!userInfo.newCoachOrderNum">客户订单</badge>
          <span style="font-size: 0.22rem; color: #666"> 用户预约我的订单</span>
        </template>
      </cell>
    </div>
    <div
      class="order-list"
      @click="goToOrderPromotion()"
      v-if="$store.state.app.userCategory == 2 && userInfo.coachType != 3"
    >
      <cell title="" value="全部订单" is-link>
        <template #title>
          <span>订单推广</span>
          <span style="font-size: 0.22rem; color: #666">生成订单推给用户</span>
        </template>
      </cell>
    </div>
    <div class="order-list" @click="$router.push('/user/user_coupon')">
      <cell title="优惠券" value="优惠券" is-link></cell>
    </div>
    <div class="order-list" @click="$router.push('/game/my?userCategory=1')">
      <cell title="参与的游戏" value="游戏" is-link></cell>
    </div>
    <div
      class="order-list"
      @click="$router.push('/game/my?userCategory=2')"
      v-if="userInfo.isCardCoach == 1"
    >
      <cell title="发起的游戏" value="游戏" is-link></cell>
    </div>

    <!-- <div class="order-list" @click="$router.push('/evaluation/my')">
      <cell title="我的测评" value="我的测评" is-link></cell>
    </div> -->

    <div class="myService" v-if="$store.state.app.userCategory == 2">
      <div class="title acea-row row-middle">
        <Icon name="user-o" size="0.36rem" />个人信息
      </div>
      <cell title="微信号" :value="userInfo.wechatNumber" />
      <cell title="手机号" :value="maskedPhone" />
      <cell
        title="基础资料"
        value=""
        is-link
        @click="$router.push({ path: '/settle_in', query: { stepActive: 1 } })"
      />
      <cell
        v-if="userInfo.coachType != 3"
        title="完善资料"
        value=""
        is-link
        @click="$router.push({ path: '/settle_in', query: { stepActive: 2 } })"
      />
      <cell
        v-if="userInfo.coachType != 3"
        title="认证资料"
        value=""
        is-link
        @click="$router.push({ path: '/settle_in', query: { stepActive: 3 } })"
      />
    </div>
    <div class="myService" v-else>
      <div class="title acea-row row-middle">
        <Icon name="user-o" size="0.36rem" />个人信息
      </div>
      <cell title="微信号" :value="userInfo.wechatNumber" />
      <cell title="手机号" :value="userInfo.phone" />
      <cell
        title="基础资料"
        value=""
        is-link
        @click="$router.push({ path: '/settle_in', query: { stepActive: 1 } })"
      />
      <cell
        title="预约资料"
        value=""
        is-link
        @click="
          $router.push({
            path: '/order/questionnaire/162',
            query: { form: 'user' },
          })
        "
      />
    </div>
    <div class="btn" @click="$router.push('/goods_list')">预约教练</div>

    <!-- isCardCoach: 1  coachType: 2 -->
    <div
      v-if="
        userInfo.isCardCoach != 1 ||
        (userInfo.isCardCoach == 1 && userInfo.cardStatus == 2) ||
        ![0, 2].includes(userInfo.coachType) ||
        ([0, 2].includes(userInfo.coachType) && userInfo.isShow == 2) ||
        ![1, 2].includes(userInfo.coachType) ||
        ([1, 2].includes(userInfo.coachType) && userInfo.welfareStatus == 2)
      "
      class="btn"
      style="background: #f6c648; color: black"
      @click="$router.push('/settle_in')"
    >
      <span>教练入驻申请</span>
    </div>
    <!-- <div v-if="!(userInfo.coachType == 2 && userInfo.isCardCoach == 1)" class="btn"
      style="background: #f6c648; color: black" @click="$router.push('/settle_in')">
      <span v-if="userInfo.userCategory == 1">
        教练入驻
      </span>
      <span v-if="![0, 1, 2].includes(userInfo.coachType) && userInfo.isCardCoach == 1">
        平台教练/公益教练 申请
      </span>
      <span v-else-if="[0].includes(userInfo.coachType) && userInfo.isCardCoach == 0">
        卡牌引导师/公益教练 申请
      </span>
      <span v-else-if="[1].includes(userInfo.coachType) && userInfo.isCardCoach == 0">
        平台教练/卡牌引导师 申请
      </span>
      <span v-else-if="[2].includes(userInfo.coachType) && userInfo.isCardCoach == 0">
        卡牌引导师 申请
      </span>
      <span v-else-if="[0].includes(userInfo.coachType) && userInfo.isCardCoach == 1">
        公益教练 申请
      </span>
      <span v-else>
        教练入驻
      </span>
    </div> -->
  </div>
</template>
<script>
import { getUserInfo, getMenuUser } from "@api/user";
import { isWeixin } from "@utils";
import { Cell, NavBar, Icon, Badge } from "vant";

const NAME = "User";

export default {
  name: NAME,
  components: {
    Cell,
    NavBar,
    Icon,
    Badge,
  },
  props: {},
  data: function () {
    return {
      userInfo: {},
      MyMenus: [{}],
      orderStatusNum: {},
      switchActive: false,
      isWeixin: false,
      maskedPhone: '',
      isShow: 0,
    };
  },
  watch: {
    $route(n) {
      if (n.name === NAME) this.User();
    },
  },
  mounted: function () {
    this.User();
    // this.MenuUser();
    this.isWeixin = isWeixin();
  },
  methods: {
    changeswitch: function (data) {
      this.switchActive = data;
    },
    User: function () {
      let that = this;
      getUserInfo().then((res) => {
        that.userInfo = res.data;
        that.isShow = res.data.isShow;
         if (this.userInfo.phone) {
            this.maskedPhone = this.userInfo.phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
         }
        this.$store.commit("SET_USER", res.data);
      });
    },

    MenuUser: function () {
      let that = this;
      getMenuUser().then((res) => {
        that.MyMenus = res.data.routine_my_menus;
      });
    },
    goPages: function (index) {
      let url = this.MyMenus[index].url;
      //console.log('user:'+this.userInfo.statu)
      if (url === "/user/user_promotion" && this.userInfo.statu === 1) {
        if (!this.userInfo.isPromoter)
          return this.$dialog.toast({ mes: "您还没有推广权限！！" });
      }

      if (url === "/customer/index" && !this.userInfo.adminid) {
        return this.$dialog.toast({ mes: "您还不是管理员！！" });
      }

      if (url === "/order/order_cancellation" && !this.userInfo.checkStatus) {
        return this.$dialog.toast({ mes: "您没有核销权限,请后台店员设置！！" });
      }

      this.$router.push({ path: this.MyMenus[index].url });
    },
    outLogin() {
      this.$dialog.confirm({
        mes: "确认退出登录?",
        opts: () => {
          this.$log.wechat("用户手动点击了退出登录", this.userInfo);
          this.$store.commit("LOGOUT");
          this.$router.push("/");
        },
      });
    },
    checkCoachStatus(userInfo, status) {
      // const result = [];
      // // 判断平台教练状态
      // if (userInfo.isShow === status && [0, 2].includes(userInfo.coachType)) {
      //   result.push('平台教练');
      // }
      // if (userInfo.welfareStatus === status && [1, 2].includes(userInfo.coachType)) {
      //   result.push('公益教练');
      // }
      // // 判断卡牌教练状态
      // if (userInfo.cardStatus === status && userInfo.isCardCoach === 1) {
      //   result.push('卡牌教练');
      // }

      // return result.join(',');
      // 判断当前教练的状态，status 1 平台教练 2 公益教练 3 卡牌教练 ， return 1 审核中 2 已拒绝 3 已审核
      if (status === 1) {
        // 前提条件是平台教练
        if ([0, 2].includes(userInfo.coachType)) {
          if (userInfo.isShow === 0) {
            return 0;
          } else if (userInfo.isShow === 1) {
            return 1;
          } else if (userInfo.isShow === 2) {
            return 2;
          }
        }
        return null;
      }

      if (status === 2) {
        // 前提条件是公益教练
        if ([1, 2].includes(userInfo.coachType)) {
          if (userInfo.welfareStatus === 0) {
            return 0;
          } else if (userInfo.welfareStatus === 1) {
            return 1;
          } else if (userInfo.welfareStatus === 2) {
            return 2;
          }
        }
        return null;
      }

      if (status === 3) {
        // 前提条件是卡牌教练
        if (userInfo.isCardCoach === 1) {
          if (userInfo.cardStatus === 0) {
            return 0;
          } else if (userInfo.cardStatus === 1) {
            return 1;
          } else if (userInfo.cardStatus === 2) {
            return 2;
          }
        }
        return null;
      }
    },
    goToOrderPromotion() {
      if (this.$store.state.app.userCategory == 2) { // 教练
        this.$router.push('/user/order_promotion');
      } else {
        this.$dialog.toast({ mes: "您当前还没有通过教练审核！" });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.user {
  .header {
    position: relative;
    margin-bottom: 0.19rem;

    .bg {
      width: 100%;
      height: 2rem;
    }

    .header-img {
      position: absolute;
      z-index: 1;
      top: 1.34rem;
      left: 50%;
      margin-left: -0.72rem;

      img {
        width: 1.44rem;
        height: 1.44rem;
        border-radius: 50%;
      }
    }

    .coach-status {
      position: absolute;
      z-index: 2;
      padding: 0 0.1rem;
      border-radius: 2px;
      bottom: 0;
      background-color: #0ce6df;
      color: #ffffff;
      font-size: 0.22rem;
      font-weight: bold;
      // width: 0.9rem;
      // left: 0.27rem;

      white-space: nowrap;
      display: flex;
      justify-content: center;
      left: 50%;
      transform: translate(-50%);
    }

    .header-flex {
      padding: 1rem 0 0.57rem;
      background-color: #ffffff;
    }

    .header-num {
      width: 1.73rem;
      text-align: center;

      .name {
        color: #999999;
        margin-bottom: 0.19rem;
      }
    }
  }

  .order-list {
    background-color: #ffffff;
    margin-bottom: 0.19rem;
  }

  .myService {
    background-color: #ffffff;
    padding: 0 0.19rem;

    .title {
      padding: 0.19rem 16px;
    }

    i {
      margin-right: 0.1rem;
    }
  }

  .btn {
    display: block;
    color: #fff;
    height: 0.68rem;
    border-radius: 0.04rem;
    background: #0ce6df;
    line-height: 0.68rem;
    text-align: center;
    border-radius: 1rem;
    margin: 0.19rem;
  }
}
</style>
